import React from 'react';
import { CashFlowPage } from './CashFlowPage';
import { PerformancePage } from './PerformancePage';
import { TrafficPage } from './TrafficPage';
import { ForecastPage } from './ForecastPage';
import { PageType } from '../modals/PageTypeSelectionModal';
import { BoardGrid } from '../BoardGrid';

interface PageRendererProps {
    pageType?: PageType | string;
    isEditMode: boolean;
    // Fallback props for BoardGrid
    board: any;
    items: any[];
    isChartLoading: boolean;
    isChartError: boolean;
    onChartErrorClick: () => void;
    onLayoutChange: () => void;
    onDragStop: any;
    onResizeStop: any;
    onDrop: any;
    onRemoveItem: any;
    droppingItem: any;
    onDrag: any;
    onAddCharts: (location?: { x: number, y: number }) => void;
    onToggleEditMode?: (enabled: boolean) => void;
}

/**
 * Registry of custom page types that have their own specialized views.
 * Pages added here will not use the standard BoardGrid.
 */
export const CUSTOM_PAGES: Record<string, React.FC<any>> = {
    'Cash Flow': CashFlowPage,
    'Performance': PerformancePage,
    'Traffic': TrafficPage,
    'Forecast': ForecastPage,
    // Future custom pages can be easily added here:
};

/**
 * Returns true if the page type is a tailored full-width page.
 */
export const isCustomPage = (pageType?: string): boolean => {
    return !!(pageType && CUSTOM_PAGES[pageType]);
};

export const PageRenderer: React.FC<PageRendererProps> = (props) => {
    const { pageType, isEditMode, onToggleEditMode } = props;

    const CustomComponent = CUSTOM_PAGES[pageType as string];

    if (CustomComponent) {
        return (
            <div className="h-full w-full flex flex-col overflow-hidden">
                <CustomComponent isEditMode={pageType === 'Performance' ? false : isEditMode} />
            </div>
        );
    }

    // Default to BoardGrid for standard pages
    return (
        <div className="p-2 lg:p-4 min-h-full">
            <BoardGrid
                board={props.board}
                items={props.items}
                isEditMode={props.isEditMode}
                isChartLoading={props.isChartLoading}
                isChartError={props.isChartError}
                onChartErrorClick={props.onChartErrorClick}
                onLayoutChange={props.onLayoutChange}
                onDragStop={props.onDragStop}
                onResizeStop={props.onResizeStop}
                onDrop={props.onDrop}
                onRemoveItem={props.onRemoveItem}
                droppingItem={props.droppingItem}
                onDrag={props.onDrag}
                onAddCharts={props.onAddCharts}
                onToggleEditMode={onToggleEditMode}
            />
        </div>
    );
};
